import React, { useEffect, useState } from "react";
import { Grid, Typography, Card, CardMedia, CardContent, Box, Chip, CircularProgress, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getAllArticles } from "../../models/Article";

export default function MainsiteSection() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [hoverTimelineId, setHoverTimelineId] = useState(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await getAllArticles();
        setArticles(res);
      } catch (err) {
        throw err;
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);
  const renderArticles = (data) => (
    <Grid container spacing={3} justifyContent="center">
      {data.map((article) => (
        <Grid item key={article.id}>
          <Card
            onClick={() => navigate(`/articles/${article.id}`)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              borderTop: '3px solid red',
              boxShadow: 'none',
              borderRadius: 0,
              width: 305,
              position: 'relative',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                transform: 'scale(1.02)',
              },
            }}
          >
            <Box position="relative">
              {article.badge && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    backgroundColor: 'crimson',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px 10px',
                    clipPath: 'polygon(100% 0, 100% 100%, 85% 100%, 0 15%, 0 0)',
                    zIndex: 1,
                  }}
                >
                  {article.badge}
                </Box>
              )}
              <CardMedia
                component="img"
                image={`${BASE_URL}${article.thumbnail}` || 'https://via.placeholder.com/312x312.png?text=No+Image'}
                alt={article.title}
                sx={{ width: 312, height: 312, objectFit: 'cover' }}
              />
            </Box>

            <Box
              sx={{
                position: 'absolute',
                top: 312,
                left: 0,
                width: '4px',
                height: 'calc(100% - 312px - 16px)',
                backgroundColor: 'red',
              }}
            />

            <CardContent sx={{ flexGrow: 1, p: 1.5 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{
                  '&:hover': { textDecoration: 'underline', textDecorationColor: 'black' },
                  mb: 2,
                  fontSize: 18,
                }}
              >
                {article.title}
              </Typography>
              <Typography variant="body2" sx={{ color: '#444', mb: 2 }}>
                {article.description?.substring(0, 100)}...
              </Typography>

              <Typography variant="caption" sx={{ color: 'gray' }}>
                {new Date(article.created_at).toLocaleDateString('vi-VN')}
              </Typography>

              <Box mt={1}>
                <span
                  className="badge bg-light text-dark"
                  onMouseEnter={() => setHoverTimelineId(article.id)}
                  onMouseLeave={() => setHoverTimelineId(null)}
                  onClick={(e) => {
                    e.stopPropagation();
                    const basePath =
                      article.category_name === "chienki" ? "/chienky" : "/luocsu";
                    const timelineQuery =
                      article.timeline_name === "1975"
                        ? "1975"
                        : article.timeline_name;

                    navigate(`${basePath}?timeline=${timelineQuery}`);
                  }}
                  style={{
                    fontSize: "15px",
                    display: "inline-block",
                    transition: "transform 0.2s ease, background-color 0.2s ease",
                    cursor: "pointer",
                    borderRadius: "4px",
                    ...(hoverTimelineId === article.id && {
                      transform: "scale(1.15)",
                      backgroundColor: "rgba(0,0,0,0.1)",
                    }),
                  }}
                >
                  {article.category_name === "luocsu"
                    ? "Lược Sử"
                    : article.category_name === "chienki"
                      ? "Chiến Ký"
                      : article.category_name}

                  {article.timeline_name && (
                    <>
                      {" - "}
                      {{
                        "1975": "Sau 1975",
                        "KCCM": "Kháng Chiến Chống Mỹ",
                        "KCCP": "Kháng Chiến Chống Pháp"
                      }[article.timeline_name] || article.timeline_name}
                    </>
                  )}
                </span>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  // --- Lọc dữ liệu ---
  const newestArticles = [...articles]
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, 4);

  const luocsuArticles = articles
    .filter((a) => a.category_name === 'luocsu')
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, 4);

  const chienkiArticles = articles
    .filter((a) => a.category_name === 'chienki')
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, 4);

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 5 }}>
      <Box sx={{ width: '100%', maxWidth: '1344px', px: 2 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={10}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* Bài Viết Mới Nhất */}
            <Box sx={{ mb: 6 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black', mb: 4, ml: 1 }}>
                Bài Viết Mới Nhất
              </Typography>
              {renderArticles(newestArticles)}
            </Box>

            {/* Lược Sử */}
            <Box sx={{ mb: 6 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black', ml: 1 }}>
                  Lược Sử
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => navigate("/luocsu")}
                  color="error"
                  sx={{
                    width: 120,
                    height: 48,
                    borderRadius: 0,
                    fontSize: 13,
                    fontWeight: 600,
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    '&:hover': {
                      backgroundColor: '#8B0000',
                    },
                    mr: 1.35
                  }}
                >
                  Xem thêm
                </Button>
              </Box>
              {renderArticles(luocsuArticles)}
            </Box>

            {/* Chiến Kí */}
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black', ml: 1 }}>
                  Chiến Ký
                </Typography>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => navigate("/chienki")}
                  sx={{
                    width: 120,
                    height: 48,
                    borderRadius: 0,
                    fontSize: 13,
                    fontWeight: 600,
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    '&:hover': {
                      backgroundColor: '#8B0000',
                    },
                    mr: 1.35
                  }}
                >
                  Xem thêm
                </Button>
              </Box>
              {renderArticles(chienkiArticles)}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
